import template from './SGrid.html';

export default {
	template,
	props: [
		'rows',
		'remote-method',
		'rows-limit',
		'query',
		'zebra',
		'default-sort',
		'filter-fn',
		'sort-fn',
		'reload-watcher',
		'loading',
		'scroll-load',
		'min-rows',
		'more-portion'
	],
	data() {
		return {
			warned: false,
			loadedRows: null,
			shouldShowAll: false,
			isLoading: false,
			isLoadingMore: false,
			isNoMore: false,
			portion: null,
			rowsToShow: null
		};
	},
	computed: {
		params() {
			return this.query || this.app.query;
		},
		allRows() {
			if (this.rows && this.remoteMethod && !this.warned) {
				console.warn('Using "rows" and "remote-method" is not allowed');
				this.warned = true;
			}
			return this.rows || this.loadedRows || [];
		},
		filteredRows() {
			let rows = this.allRows;
			if (!this.filterFn) return rows;
			return rows.filter(this.filterFn);
		},
		sortedRows() {
			let rows = this.filteredRows;

			if (this.sortFn === null) return rows;
			if (this.sortFn) return this.sortFn(rows);

			let sort = this.params.sort || this.defaultSort;
			if (!sort) return rows;

			let dir = 1;
			if (sort[0] === '-') {
				sort = sort.slice(1);
				dir = -1;
			}

			return rows.sort((a, b) => {
				if (a[sort] > b[sort]) return dir;
				if (a[sort] < b[sort]) return -dir;

				return 0;
			});
		},
		finalRows() {
			let rows = this.sortedRows;

			if (this.rowsToShow && !this.shouldShowAll) {
				rows = rows.slice(0, this.rowsToShow);
			}

			if (this.minRows && !this.isLoading) {
				for (let i = rows.length; i < this.minRows; i++) {
					rows.push(null);
				}
			}

			return rows;
		}
	},
	methods: {
		async loadData(append, params = null) {
			if (!this.remoteMethod) return;

			if (append) {
				if (this.isLoading || this.isLoadingMore || this.isNoMore) return;

				this.portion++;
				this.isLoadingMore = true;
			} else {
				this.portion = 0;
				this.rowsToShow = parseInt(this.rowsLimit) || null;
				this.shouldShowAll = false;
				this.isLoading = true;
				this.isNoMore = false;
			}

			let res;
			if (!params) {
				params = this.app.query;
			}

			if (!this.portion || this.scrollLoad !== 'ids') {
				res = await this.http.get(this.remoteMethod, params, this.portion);
			} else {
				let ids = (this.loadedRows || []).map(r => r.id);
				res = await this.http.post(this.remoteMethod, params, this.portion, ids);
			}
			this.$emit('load', res);
			this.isLoading = false;

			if (append) {
				this.isLoadingMore = false;
				this.loadedRows = this.loadedRows.concat(res.rows);
			} else {
				this.isLoading = false;
				this.loadedRows = res.rows;
			}

			if (res.rows.length === 0) {
				this.isNoMore = true;
			}
		},
		toggleLimit() {
			if (this.morePortion && !this.shouldShowAll) {
				this.rowsToShow += parseInt(this.morePortion) || 0;
				if (this.rowsToShow > this.filteredRows.length) {
					this.rowsToShow = this.filteredRows.length;
					this.shouldShowAll = true;
				}
			} else {
				this.rowsToShow = parseInt(this.rowsLimit) || null;
				this.shouldShowAll = !this.shouldShowAll;
			}
		},
		onScroll() {
			if (this.scrollLoad === 'off') return;

			let OFFSET = 200;

			let scrollBottom = this.win.scrollTop + this.win.height;
			let docHeight = document.body.scrollHeight;

			if (scrollBottom > docHeight - OFFSET) {
				this.loadData(true);
			}
		}
	},
	watch: {
		reloadWatcher() {
			this.loadData();
		}
	},
	mounted() {
		this.rowsToShow = parseInt(this.rowsLimit) || null;
		this.loadData();
		window.addEventListener('scroll', this.onScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.onScroll);
	}
};